import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Mail: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 12.0001V22.008L12.006 22.002L24.012 21.996L24.018 11.988L24.024 1.97998L12.012 1.98603L0 1.99208V12.0001ZM0.01188 12C0.01188 17.511 0.01464 19.7655 0.018 17.01C0.02136 14.2545 0.02136 9.74549 0.018 6.98998C0.01464 4.23449 0.01188 6.48898 0.01188 12ZM1.99764 4.70614L2.004 5.4043L6.99396 8.12614C9.73846 9.62316 11.9912 10.848 12 10.848C12.0088 10.848 14.2615 9.62316 17.006 8.12614L21.996 5.4043L22.0024 4.70614L22.0087 4.00798H12H1.99128L1.99764 4.70614ZM1.992 13.8454V19.992H12H22.008V13.8454C22.008 8.00149 22.0059 7.69964 21.966 7.71476C21.9429 7.72349 19.6974 8.94504 16.976 10.4293C14.2547 11.9136 12.0154 13.128 12 13.128C11.9846 13.128 9.74534 11.9136 7.02396 10.4293C4.30258 8.94504 2.05711 7.72349 2.034 7.71476C1.99406 7.69964 1.992 8.00149 1.992 13.8454Z'
        fill={fill}
      />
    </svg>
  )
}

export default Mail
